import * as SetDisplayModeActions from '../actions/displayMode';
export default function displayModeReducer(displayMode, action) {
    switch (action.type) {
        case SetDisplayModeActions.SET_DISPLAY_MODE:
            localStorage.setItem('displayMode', action.data.id);
            return action.data;
    }
    return displayMode;
}



// WEBPACK FOOTER //
// ./src/reducers/displayModeReducer.js